/* eslint-disable*/
var checkCfa3Subscription = function checkCfa3Subscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  // console.log(selectedLevel);
  // console.log(exam_data);
  // console.log(cfaUnlimitedPackage);
  // console.log(cfaUnlimitedActiveExam);
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (exam_data[i].levels[j].isActive) {
              // console.log("uppercase");

              flag = true;
              break;
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        // console.log("work");
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 20 ||
                exam_data[i].levels[j].package_id === 21 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 49 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 22)
            ) {
              // console.log("lowecase");

              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
    //return final_exam.indexOf(selectedmen) > -1;
  }
};

var checkCfa3NotesSubscription = function checkCfa3NotesSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 21
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 20 ||
                exam_data[i].levels[j].package_id === 21 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 49 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 22)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

/*
------------------------
  Check for videos
-----------------------
*/
var checkCfa3VideosSubscription = function checkCfa3VideosSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 21
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 20 ||
                exam_data[i].levels[j].package_id === 21 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 49 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 22)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

/*
-----------------------
  Check for PDF's
----------------------
*/
var checkCfa3PDFSubscription = function checkCfa3PDFSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  type
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === 'question') {
                flag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === 'notes'
              ) {
                flag = true;
              }
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 21
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 20 ||
                exam_data[i].levels[j].package_id === 21 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 49 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 22)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

exports.checkCfa3NotesSubscription = checkCfa3NotesSubscription;
exports.checkCfa3VideosSubscription = checkCfa3VideosSubscription;
exports.checkCfa3PDFSubscription = checkCfa3PDFSubscription;
exports.checkCfa3Subscription = checkCfa3Subscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/Cfa3Subscription.js